import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { EventManagerPlugin } from '@angular/platform-browser';

/**
 * {@link https://angular.dev/api/platform-browser/EventManagerPlugin | EventManagerPlugin} for `.stop` —
 * declarative `stopPropagation()` in templates, same extensibility model as `keydown.enter`.
 * Registered via {@link https://angular.dev/api/platform-browser/EVENT_MANAGER_PLUGINS | EVENT_MANAGER_PLUGINS}.
 *
 * @example
 * ```html
 * <button (click.stop)="onCopy()">Copy</button>
 * ```
 *
 * @see {@link https://angular.dev/guide/templates/event-listeners#extend-event-handling | Extend event handling}
 */
@Injectable()
export class StopEventPlugin extends EventManagerPlugin {
    constructor(@Inject(DOCUMENT) doc: Document) {
        super(doc);
    }

    override supports(eventName: string): boolean {
        return eventName.split('.').includes('stop');
    }

    override addEventListener(
        element: HTMLElement,
        eventName: string,
        handler: Function
    ): Function {
        const wrapped = (event: Event) => {
            event.stopPropagation();
            handler(event);
        };

        return this.manager.addEventListener(
            element,
            eventName.replace('.stop', ''),
            wrapped
        );
    }
}
